import React, { useState } from "react";
import { Link } from "react-router-dom";
import { requestPasswordReset } from "../../api/auth";
import { Button } from "../../components/Button";
import { TextField } from "./TextField";

interface RequestResetFormProps {
}

const RequestResetForm: React.FC<RequestResetFormProps> = (props) => {
	const [email, setEmail] = useState("");
	const [loading, setLoading] = useState(false);
	const [errors, setErrors] = useState<Record<string, string[]>>();
	const [sent, setSent] = useState<boolean>(false);

	const handleReset = async () => {
		setErrors(undefined);
		setLoading(true);
		const res = await requestPasswordReset(email);
		setLoading(false);
		if (!res.ok) {
			setErrors(res.errors);
			return;
		}
		setSent(true);
	};
	return (
		<div className={"flex flex-col w-64"}>
			<div className={"flex flex-col mb-4"}>
				<TextField label={"Email"} value={email} onChange={setEmail} />
				{sent && (
					<div className={"text-green-400 text-xs"}>If your email exists, you will be sent a link to reset
						your
						password.</div>
				)}
			</div>

			<div className={"flex justify-between items-center"}>
				{!loading && !sent &&
					<Button className={"px-6"} onClick={handleReset}>
						Request Reset
					</Button>
				}
				{sent && <div></div>}
				{loading && <div className={"text-slate-200"}>Loading...</div>}
				<div>
					<Link to={"/login"} className={"text-slate-200"}>
						Back
					</Link>
				</div>
			</div>
		</div>
	);
};

export { RequestResetForm };